export default __webpack_public_path__ + "static/media/PurchaseLinkIndicatorInActive.2cbd19fd.svg";